import { render, staticRenderFns } from "./BoasVindas.vue?vue&type=template&id=5f6e74b9&scoped=true"
var script = {}
import style0 from "./BoasVindas.vue?vue&type=style&index=0&id=5f6e74b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e74b9",
  null
  
)

export default component.exports